module.exports = __webpack_public_path__ + "img/edit-icon.1eb6ac01.svg";